module.exports = __webpack_public_path__ + "static/media/my-team.1efa0a57.svg";